// Client-safe Polar price types + formatting. NO server imports (no SDK, no
// next/cache) so this is safe to import from client components (cardPrice).
// The server resolver lives in `./polarPrice`.

export type ResolvedPrice = {
  amount: number // major units (e.g. 20)
  currency: string // e.g. 'USD'
  interval: 'month' | 'year' | null // null = one-time
  isRecurring: boolean
}

/** Format a resolved Polar price as the bare amount, e.g. "$20" or "$72".
 *  The cadence ("/mo" / "One-Time") renders separately — see `cadenceLabel`. */
export function formatPolarPriceText(p: ResolvedPrice): string {
  const symbol = p.currency === 'USD' ? '$' : ''
  const whole = Number.isInteger(p.amount) ? String(p.amount) : p.amount.toFixed(2)
  return symbol ? `${symbol}${whole}` : `${whole} ${p.currency}`
}

/** Cadence label shown muted next to the price: "/mo" / "/yr" for
 *  subscriptions, "One-Time" for one-time products. Matches the app paywall. */
export function cadenceLabel(p: ResolvedPrice): string {
  if (!p.isRecurring || !p.interval) return 'One-Time'
  return p.interval === 'year' ? '/yr' : '/mo'
}
